var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
export var getSrcSet = function (id, format, images) {
    return images
        .map(function (image) {
        var url = format === "webp" ? image.urls.webp : image.urls.jpeg;
        return "".concat(url, " ").concat(image.srcWidth);
    })
        .join(", ");
};
export var getSizes = function (images) {
    return images
        .filter(function (image) { return image.query; })
        .map(function (image) { return image.query; })
        .join(", ");
};
export var ResponsiveImage = function (_a) {
    var id = _a.id, images = _a.images, alt = _a.alt, className = _a.className;
    return (React.createElement(PictureStyled, { className: className },
        React.createElement("source", { srcSet: getSrcSet(id, "webp", images), type: "image/webp" }),
        React.createElement("img", { srcSet: getSrcSet(id, "jpg", images), sizes: getSizes(images), src: getSrcSet(id, "jpg", images), alt: alt })));
};
var PictureStyled = styled.picture(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n\n  img {\n    height: auto;\n    display: block;\n  }\n"], ["\n  width: 100%;\n\n  img {\n    height: auto;\n    display: block;\n  }\n"])));
var templateObject_1;
